import { render, staticRenderFns } from "./modal-transfer-channel.html?vue&type=template&id=2785c02c&scoped=true&"
import script from "./modal-transfer-channel.js?vue&type=script&lang=js&"
export * from "./modal-transfer-channel.js?vue&type=script&lang=js&"
import style0 from "./modal-transfer-channel.scss?vue&type=style&index=0&id=2785c02c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2785c02c",
  null
  
)

export default component.exports